Vue.component('repeatable', {
    props: {
        max: {
            type: Number,
            default: 99
        },
        itemErrors: {
            type: Array,
            default: []
        },
        itemList: {
            type: Array,
            default: []
        },
        token: String
    },
    data: function() {
        return {
            items: []
        };
    },
    watch: {
        items: {
            handler: function(items, oldItems) {
                items.forEach(function(item) {
                    if (! item.errors) {
                        item.errors = {};
                    }
                });

                Vue.nextTick(function() {
                    jQuery(document).trigger('repeatable-reinit');
                });
            },
            deep: false
        }
    },
    beforeMount: function() {
        // Parse items from JSON
        if(this.itemList !== null) {
            this.items = this.itemList.map(function (item) {
                item.errors = {};
                return item;
            })
        }

        // Parse errors into each specific item
        this.mergeErrors();
    },
    mounted: function() {
        // Start with empty row when empty
        if (this.items.length === 0) {
            this.addItem();
        }
    },
    methods: {
        /**
         * Merge error messages in items array
         */
        mergeErrors: function() {
            for (var rule in this.itemErrors) {
                var ruleParts = rule.split('.');
                var index = parseInt(ruleParts[1], 10);
                var name = ruleParts[2];
                var messages = this.itemErrors[rule];

                // Item doesn't exist?
                if (! (index in this.items)) {
                    continue;
                }

                // Set errors
                this.items[index].errors[name] = messages[0];
            }
        },
        /**
         * Add a new empty item
         */
        addItem: function () {
            if (this.items.length >= this.max) {
                return;
            }
            this.items.push({});
        },
        /**
         * Check if item has a value
         */
        hasValue: function(item) {
            var hasValue = false;
            var key, value;

            for (key in item) {
                value = item[key];
                if (item.hasOwnProperty(key) && key !== 'errors' && value) {
                    hasValue = true;
                }
            }

            return hasValue;
        },
        /**
         * Remove item by index
         */
        removeItem: function (index) {
            var item = this.items[index];
            var accepted = true;

            if (this.hasValue(item)) {
                //accepted = confirm('Weet je het zeker dat je dit wilt verwijderen?');
            }

            if (accepted) {
                this.items.splice(index, 1);
            }
        }
    }
});